<section
  class="row details-content no-padding no-margin-horizontal margin-top mt32 mobile-margin"
>
     <app-home-header    [policy]="policy" *ngIf="!isAcmic" class="w-100"></app-home-header>
  <div
    class="col-sm-12 col-md col1"
    [ngClass]="{ 'details-all-width-left': isAcmic }"
  >
    <div
      *ngIf="!isAcmic && policy?.displayType?.label === 'Personal property' && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'"
    >
      <div class="row margin-bottom mb24 row-section">
        <div class="col">
          <h2
            class="title mortgagee-title margin-bottom mb16"
            [ngClass]="{ 'dm-sans-medium lh-24-imp': !isAcmic, 'fw-400': isAcmic }"
          >
            {{ 'MORTGAGEE_DETAILS' | translate }}
          </h2>

          <div class="mortgagee-row" [ngClass]="{ 'gap-8': !isAcmic}">
            <div class="mortgagee-left mortgagee-left-home">
              <span class="mortgagee-text">
                {{ 'MORTGAGEE_TEXT' | translate }}
              </span>
              <app-mortgagee-custom-tooltip></app-mortgagee-custom-tooltip>
            </div>

            <div *ngIf="policy?.billingDetails?.mortgagee && policy?.billingDetails?.mortgagee?.name && policy?.billingDetails?.mortgagee?.address" class="mortgagee-right">
              <div class="company-name lh-21">
                {{ policy?.billingDetails?.mortgagee?.name | titlecase}}
              </div>

              <div class="lh-24 mrb-1 h-21">
                {{ policy?.billingDetails?.mortgagee?.address?.line1 }}
              </div>

              <div class="lh-24 h-21">
                {{ policy?.billingDetails?.mortgagee?.address?.city }},
                {{ policy?.billingDetails?.mortgagee?.address?.state }}
                {{ policy?.billingDetails?.mortgagee?.address?.zip?.code }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row margin-bottom mb16 policy-holders row-section" [ngClass]="{'no-margin-horizontal margin-bottom mb24 policy-holder-mobile': !isAcmic}">
      <div class="col" [ngClass]="{'no-padding-horizontal': !isAcmic}">
        <h2
          class="title"
          [ngClass]="{ 'dm-sans-medium lh-24-imp policy-holder-heading': !isAcmic, 'fw-400 margin-bottom mb16': isAcmic }"
        >
          {{ 'POLICY_HOLDER_ONE_WORD' | translate
          }}{{ policy.insured.length > 1 ? 's' : '' }}
        </h2>

        <div
          class="policy-holder row "
          [ngClass]="{'margin-bottom mb16 align-items-center flex-nowrap': isAcmic, 'no-margin-horizontal gap-8 gap-4-mobile': !isAcmic}"
          *ngFor="let holder of policy?.insured | sort : 'isPrimaryInsured'"
        >
        <ng-container *ngIf="isAcmic">
            <div class="col-auto"  [ngClass]="{'no-padding-horizontal insured-text': !isAcmic}" >
            <h3
              class="title vehicle-name text-capitalize col-2d373d holder-name-text"
              [ngClass]="{ 'col-363636-imp': isAcmic }"
            >
              {{ holder['Insured Name'] | titlecase }}
            </h3>
          </div>
        </ng-container>

          <div
            class="col-auto primary-label-text" [ngClass]="{'no-padding-horizontal': !isAcmic}"
            *ngIf="
              holder?.isPrimaryInsured && policy?.company.companyName === 'MA'
            "
          >
            <small
              class="fs-16 col-526570"
              [ngClass]="{ 'small-text': !isAcmic, 'col-656565-imp': isAcmic }"
              >{{ 'PRIMARY' | translate }}</small
            >
          </div>
          <div
            class="col-auto primary-label-text" [ngClass]="{'no-padding-horizontal secondary-label-text': !isAcmic}"
            *ngIf="
              !holder?.isPrimaryInsured && policy?.company.companyName === 'MA'
            "
          >
            <small
              class="fs-16 col-526570"
              [ngClass]="{ 'small-text ': !isAcmic, 'col-656565-imp': isAcmic }"
              >{{ 'SECONDARY' | translate }}</small
            >
          </div>
          <ng-container *ngIf="!isAcmic">
              <div class="col-auto"  [ngClass]="{'no-padding-horizontal insured-text': !isAcmic}">
            <h3
              class="title vehicle-name text-capitalize col-2d373d holder-name-text"
              [ngClass]="{ 'col-363636-imp': isAcmic }"
            >
              {{ holder['Insured Name'] | titlecase }}
            </h3>
          </div>
          </ng-container>   
        </div>
      </div>
    </div>

    <div class="row property" [ngClass]="{'margin-bottom mb-4': !isAcmic, 'margin-bottom mb40 margin-top mt16': isAcmic}">
      <div class="col">
        <h2 class="title margin-bottom mb16" [ngClass]="{ 'fw-400': isAcmic, 'lh-24-imp': !isAcmic }">
          {{ 'PROPERTY_COVERED' | translate }}
        </h2>
        <div class="margin-bottom mb16">
          <div class="text-capitalize d-flex align-items-start address-tag-row">
            <span class="mr16 address-tag-text" *ngIf="!isAcmic">{{ 'ADDRESS' | translate }}</span>
            <strong class="fs-16 address-value-text" [ngClass]="{ 'col-363636-imp': isAcmic }">
              <img
                src="{{ policy?.displayType?.icon }}"
                width="24"
                height="24"
                alt="home icon"
                *ngIf="
                  policy?.company.companyName === 'TW' ||
                  policy?.company.companyName === 'ACIC'
                "
              />
              {{ policy?.residentialAddress?.streetName | titlecase }}
             <br  *ngIf="!isAcmic">
              {{ policy?.residentialAddress?.city | titlecase }},
              {{ policy?.residentialAddress?.state | fullstateToAbv }},
              {{ policy?.residentialAddress?.zipCode.code }}
            </strong>
          </div>
          <div *ngIf="aptDiv === true">
            {{ 'APARTMENT' | translate }}: <strong> {{ apt }}</strong>
          </div>
        </div>

        <iframe
          [height]="isMobile ? 220 : 360"
          id="gmap_canvas"
          [src]="safeURL"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        >
        </iframe>
      </div>
    </div>
  </div>

  <div
    class="col-sm-12 col-md col2 old-billing-overview-width details-home-col2-pad"
    [ngClass]="{ 'details-all-width-right vertical-line-color': isAcmic }"
  >
    <app-details-sidebar
      [policy]="policy"
      (showToast)="showToast.emit($event)"
    ></app-details-sidebar>
  </div>
</section>
